$(document).ready(function() {
    $('.tabs-content .tabcontent').hide();
    $('.tabs-content .tabcontent:first').show();
    $('.tab-btn .tablink:first').addClass('active');
    $('.tablink').click(function() {
        $('.tablink').removeClass('active');
        $(this).addClass('active');
        $('.tabs-content .tabcontent').hide();
        var index = $(this).index();
        $('.tabs-content .tabcontent').eq(index).show();
    });
});
$(document).ready(function () {
    function isMobileView() {
        return window.matchMedia('(max-width: 767px)').matches;
    }

    function scrollActiveTabButton($tabBtnWrap, $tabs, activeIndex, isInitial) {
        if (!isMobileView() || !$tabBtnWrap.length) {
            return;
        }

        const wrapEl = $tabBtnWrap.get(0);
        const $activeTab = $tabs.eq(activeIndex);

        if (!$activeTab.length || !wrapEl) {
            return;
        }

        const maxScrollLeft = wrapEl.scrollWidth - wrapEl.clientWidth;
        if (maxScrollLeft <= 0) {
            return;
        }

        // Keep edge tabs pinned to edges; center middle tabs.
        if (activeIndex === 0) {
            $tabBtnWrap.stop(true).animate({ scrollLeft: 0 }, isInitial ? 0 : 250);
            return;
        }

        if (activeIndex === $tabs.length - 1) {
            $tabBtnWrap.stop(true).animate({ scrollLeft: maxScrollLeft }, isInitial ? 0 : 250);
            return;
        }

        const activeLeft = $activeTab.position().left + $tabBtnWrap.scrollLeft();
        const centeredLeft = activeLeft - (($tabBtnWrap.innerWidth() - $activeTab.outerWidth()) / 2);
        const targetScrollLeft = Math.max(0, Math.min(centeredLeft, maxScrollLeft));
        $tabBtnWrap.stop(true).animate({ scrollLeft: targetScrollLeft }, isInitial ? 0 : 250);
    }

    $('.shopify-section.index-section.Multi-Collection2').each(function () {
        let startX = 0;
        let endX = 0;
        const $section = $(this);
        const $tabs = $section.find('.tab-btn .tablinks');
        const $contents = $section.find('.tabs-content .tabcontents');
        const $tabBtnWrap = $section.find('.tab-btn');

        if (!$tabs.length || !$contents.length) {
            return;
        }

        function setActiveTab(index, isInitial) {
            $tabs.removeClass('active');
            $tabs.eq(index).addClass('active');
            $contents.hide().eq(index).show();
            scrollActiveTabButton($tabBtnWrap, $tabs, index, isInitial);
        }

        // Initial state
        setActiveTab(0, true);

        // Tab click
        $tabs.on('click', function () {
            const index = $(this).index();
            setActiveTab(index, false);
        });

        // Swipe detection
        $section.find('.tabs-content').on('touchstart', function (e) {
            startX = e.originalEvent.touches[0].clientX;
        });

        $section.find('.tabs-content').on('touchend', function (e) {
            endX = e.originalEvent.changedTouches[0].clientX;
            const diff = startX - endX;
            const activeIndex = $tabs.filter('.active').index();

            // Swipe left -> next tab
            if (diff > 50 && activeIndex < $tabs.length - 1) {
                setActiveTab(activeIndex + 1, false);
            }

            // Swipe right -> previous tab
            if (diff < -50 && activeIndex > 0) {
                setActiveTab(activeIndex - 1, false);
            }
        });
    });
});

function truncateText() {
    document.querySelectorAll('.product-short p span, .product-short p, .product-short').forEach(function(element) {
        if (element.textContent.length > 35) {
            element.textContent = element.textContent.substring(0, 35) + '...';
        }
    });
}
truncateText();
setInterval(truncateText, 10);

var swiperSingle = new Swiper(".swiper.isbest-seller", {
        slidesPerView: 4,
        spaceBetween: 20,
        breakpoints: {
            320: { slidesPerView: 1.3, spaceBetween: 10, },
            499: { slidesPerView: 1.3, spaceBetween: 10, },
            768: { slidesPerView: 3, spaceBetween: 20, },
            1080: { slidesPerView: 3, spaceBetween: 20, },
            1440: { slidesPerView: 4, spaceBetween: 20, },
        },
});
var swiperMulti = new Swiper(".swiper.ismulti-seller", {
        slidesPerView: 4,
        spaceBetween: 20,
        breakpoints: {
            320: { slidesPerView: 1.3, spaceBetween: 10, },
            499: { slidesPerView: 1.3, spaceBetween: 10, },
            768: { slidesPerView: 3.125, spaceBetween: 20, },
            1080: { slidesPerView: 3.5, spaceBetween: 20, },
            1440: { slidesPerView: 4, spaceBetween: 20, },
        },
});

var swiperBlog = new Swiper(".swiper.is-blog", {
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination-blog",
          clickbale: true,
        },
        breakpoints: {
            320: { slidesPerView: 1.3, spaceBetween: 10, },
            499: { slidesPerView: 1.3, spaceBetween: 10, },
            768: { slidesPerView: 2.125, spaceBetween: 20, },
            1080: { slidesPerView: 3, spaceBetween: 20, },
            1440: { slidesPerView: 3, spaceBetween: 30, },
        },
});

var swiperMultis = new Swiper(".swiper.ismultis-seller", {
        slidesPerView: 2,
        spaceBetween: 20,
        breakpoints: {
            320: { slidesPerView: 1, spaceBetween: 10, },
            499: { slidesPerView: 1.25, spaceBetween: 10, },
            768: { slidesPerView: 2, spaceBetween: 20, },
            1440: { slidesPerView: 2, spaceBetween: 20, },
        },
});
var swiperLearn = new Swiper(".swiper.islearn", {
        slidesPerView: 4,
        spaceBetween: 20,
        // navigation: {
        // nextEl: ".arrow.next",
        // prevEl: ".arrow.prev",
        // },
        breakpoints: {
            320: { slidesPerView: 1.3, spaceBetween: 10, },
            499: { slidesPerView: 1.3, spaceBetween: 10, },
            768: { slidesPerView: 2.5, spaceBetween: 20, },
            1080: { slidesPerView: 3.5, spaceBetween: 20, },
            1440: { slidesPerView: 4, spaceBetween: 20, },
        },
});
var swiperWhat = new Swiper(".swiper.is-what", {
        slidesPerView: 4,
        spaceBetween: 20,
        navigation: {
        nextEl: ".arrow.next1",
        prevEl: ".arrow.prev1",
        },
        pagination: {
          el: ".swiper-pagination-fraction",
          type: "fraction",
        },
        scrollbar: {
          el: '.swiper-pagination-slider',
        },
        breakpoints: {
            320: { slidesPerView: 1, spaceBetween: 10, },
            499: { slidesPerView: 1, spaceBetween: 10, },
            768: { slidesPerView: 3.125, spaceBetween: 20, },
            1080: { slidesPerView: 3.5, spaceBetween: 20, },
            1440: { slidesPerView: 4, spaceBetween: 20, },
        },
});


var swiperCardimage = new Swiper(".swiper.iscardimages", {
        slidesPerView: 1,
        spaceBetween: 20,
        // navigation: {
        // nextEl: ".arrow.next1",
        // prevEl: ".arrow.prev1",
        // },
        pagination: {
          el: ".swiper-pagination-fraction",
          type: "fraction",
        },
        scrollbar: {
          el: '.swiper-pagination-slider',
        },
        breakpoints: {
            320: { slidesPerView: 1, spaceBetween: 10, },
            499: { slidesPerView: 1, spaceBetween: 10, },
            768: { slidesPerView: 3.125, spaceBetween: 20, },
            1080: { slidesPerView: 3.5, spaceBetween: 20, },
            1440: { slidesPerView: 4, spaceBetween: 20, },
        },
});

var swiperFeatured = new Swiper(".swiper.is-featured", {
        slidesPerView: 4,
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination-featured",
          clickbale: true,
        },
        breakpoints: {
            320: { slidesPerView: 1.125, spaceBetween: 10, },
            499: { slidesPerView: 2.125, spaceBetween: 10, },
            768: { slidesPerView: 3.125, spaceBetween: 20, },
            1080: { slidesPerView: 3.5, spaceBetween: 20, },
            1440: { slidesPerView: 4, spaceBetween: 20, },
        },
});
